window.addEventListener('load', () => {
  const wrapper = document.querySelector('.product__info-wrapper');
  if (wrapper) {
    let hasScrolled = false;

    const isTallerThanViewport = () => wrapper.offsetHeight > window.innerHeight;

    if (!isTallerThanViewport()) {
      wrapper.style.setProperty('--fade-opacity', 0);
    } else {
      wrapper.style.setProperty('--fade-opacity', 1);
    }

    window.addEventListener('scroll', () => {
      hasScrolled = true;
      wrapper.style.setProperty('--fade-opacity', 0);
    }, { passive: true, once: true });

    const resizeObserver = new ResizeObserver(() => {
      if (hasScrolled) return; // don't bring it back after user has scrolled
      wrapper.style.setProperty('--fade-opacity', isTallerThanViewport() ? 1 : 0);
    });

    resizeObserver.observe(wrapper);
  }
});